import { api } from '@services';

const deleteResource = async (id: string): Promise<void> => {
  await api.delete<void>(`/resources/${id}`);
};

export { deleteResource };
